/** @format */

import { TailSpin } from "react-loading-icons";

const Loading = () => {
  return (
    <div className='vh-100'>
      <TailSpin
        stroke='#4d4d4d'
        className='position-fixed'
        style={{ left: "50%", top: "50%", transform: "translate(-50%, -50%)" }}
      />
      <span
        className='position-fixed text-dark f-14 mt-5'
        style={{ left: "50%", top: "50%", transform: "translate(-50%, -50%)" }}
      >
        در حال بارگذاری...
      </span>
    </div>
  );
};

export default Loading;
